import { getRequest, postRequest, putRequest } from "../services/apiHelpers";

export const postAlert = async (payload) => {
  try {
    const res = await postRequest({ url: "/alerts", payload: payload });
    return res;
  } catch (e) {
    throw e;
  }
};

export const putAlert = async ({ id, payload }) => {
  try {
    const res = await putRequest({
      url: "/alerts",
      query: { alert_id: id },
      payload: payload,
    });
    return res;
  } catch (e) {
    throw e;
  }
};

export const getAlerts = async (query) => {
  try {
    const res = await getRequest({
      url: "/alerts",
      query: query,
    });
    return res;
  } catch (e) {
    throw e;
  }
};
